import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import './style.css';
import App from './App.vue';
import VueLazyload from 'vue-lazyload';
import router from './router';

const app = createApp(App);
const head = createHead();

// // WebSocket handling logic
// let socket;

// const openWebSocket = () => {
//   socket = new WebSocket('ws://example.com'); // Replace with your WebSocket URL
//   socket.onopen = function () {
//     console.log('WebSocket connection established');
//   };
//   socket.onclose = function () {
//     console.log('WebSocket connection closed');
//   };
// };

// // Close WebSocket connection when navigating away
// window.addEventListener('beforeunload', () => {
//   if (socket) {
//     socket.close(); // Ensure WebSocket is closed to allow bfcache
//   }
// });

// // Open WebSocket connection when the app loads
// window.addEventListener('load', () => {
//   openWebSocket();
// });

app.use(head);
app.use(router); // Use the router
app.use(VueLazyload); // VueLazyload should be used before mounting

app.mount('#app'); // Mount only after all plugins are applied
